import { render, staticRenderFns } from "./FloatingContent.vue?vue&type=template&id=ed852508"
import script from "./FloatingContent.vue?vue&type=script&lang=js"
export * from "./FloatingContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports